module.exports = __webpack_public_path__ + "static/media/sort-circle-down.622117e7.svg";